// exports areEqual, areNear, arrayAreEqual, arrayAreNear
//         concat, flatten, findByType, filterByType, filterRight,
//         fairSpread

import { isEqual, isNumber, forEach, forEachRight, find, filter } from 'lodash';
import { createPromise } from './promise';

let arrayAreEqual, arrayAreNear;

export const areEqual = function(o1,o2) {
  if( o1 && o2 ) {
    if( o1.isEqual ) {
      return o1.isEqual(o2);
    }
    else if( typeof o1 === 'string' ) {
      return o1 === o2;
    }
    else if( o1.length !== undefined ) {
      return arrayAreEqual(o1,o2);
    }
    else {
      return isEqual(o1,o2);
    }
  }
  else {
    return o1 === o2;
  }
};

export const areNear = function(o1,o2,eps) {
  if( o1 && o2 ) {
    if( o1.isNear ) {
      return o1.isNear(o2,eps);
    }
    else if( o1.length !== undefined ) {
      return arrayAreNear(o1,o2,eps);
    }
    else if( isNumber(o1) ) {
      return Math.abs(o1-o2)< ( eps || 0.001 );
    }
    else {
      return isEqual(o1,o2);
    }
  }
  else if( isNumber(o1) ) {
    return Math.abs(o1-o2)< ( eps || 0.001 );
  }
  else {
    return o1 === o2;
  }
};

arrayAreEqual = function(array1, array2) {
  if( array1.length !== array2.length ) {
    return false;
  }
  for( let i = 0, iEnd = array1.length; i<iEnd; ++i ) {
    if( ! areEqual(array1[i],array2[i]) ) {
      return false;
    }
  }
  return true;
};

arrayAreNear = function(array1, array2, eps) {
  if( array1.length !== array2.length ) {
    return false;
  }
  for( let i = 0, iEnd = array1.length; i<iEnd; ++i ) {
    if( ! areNear(array1[i],array2[i],eps) ) {
      return false;
    }
  }
  return true;
};

export const setForEach = function(things,member,value) {
  forEach( things, thing => {
    thing[member] = value;
  });
};

export const remove = function(things,v) {
  const i = things.indexOf(v);
  if( i !== -1 ) {
    things.splice(i,1);
  }
};

export const filterByType = function(things,Type) {
  return filter( things, t => t instanceof Type );
};

export const findByType = function(things,Type) {
  return find( things, t => t instanceof Type );
};

// Return all the elements that pass a truth test.
export const filterRight = function(obj,iterator) {
  const results = [];
  if( obj.length === 0 ) {
    return results;
  }
  forEachRight( obj, (value,index,list) => {
    if(iterator(value,index,list)) {
      results[results.length] = value;
    }
  });
  return results;
};

// Spreads an array in 'count' bins with the smallest
// possible difference in quantity between theme

export function fairSpread(a,count) {
  let c = [];
  const r = [ c ];
  let n = 0, length = a.length, nc;
  const size = Math.floor( length / count );
  let extra = length - count*size;

  nc = size + ( extra > 0 ? 1 : 0 );
  while( n < length ) {
    if( nc === 0 ) {
      c = [];
      r.push( c );
      extra--;
      nc = size + ( extra > 0 ? 1 : 0 );
    }
    c.push( a[n] );
    nc--;
    n++;
  }
  return r;
}


// [TODO] This is not longer needed, remove

export const attachImageLoadEvent = function( img, handler, scope ) {
  const eventName = 'load';
  if(img.addEventListener) {
    img.addEventListener(eventName, () => {
      handler.call(scope);
    }, false);
  } else if(img.attachEvent) {
    img.attachEvent('on' + eventName, () => {
      handler.call(scope);
    });
  }
};

export const detachImageLoadEvent = function( img, handler ) {
  const eventName = 'load';
  if(img.removeEventListener) {
    img.removeEventListener(eventName, handler, false);
  } else if(img.detachEvent) {
    img.detachEvent('on' + eventName, handler);
  }
};



const userAgent = navigator.userAgent.toLowerCase();
const is_firefox = userAgent.indexOf('firefox') > -1;
const is_safari = userAgent.indexOf('safari') > -1 && userAgent.indexOf('chrome') === -1 && userAgent.indexOf('android') === -1;

export const supportsCrossOriginImages = 'crossOrigin' in ( new Image() ) &&
                                         ! is_safari; // image on load is not working if I set image.crossOrigin = "Anonymous"


export function imagePromise(src) {
  return createPromise( resolve => {

  const image = new Image();

  // Avoid tainted canvas issue, IE doesn't support this
  if( supportsCrossOriginImages ) {
    image.crossOrigin = "Anonymous";
  }

  const onLoad = () => {
    detachImageLoadEvent(image,onLoad);
    resolve(image);
  };
  attachImageLoadEvent(image,onLoad);
  image.src = src;

  });
}



/** WEBPACK FOOTER **
 ** ./src/gear/util.js
 **/